
<div class="report-header">
  <div class="report-name"> {{tranKey(moi.SCHEDULE_MANAGER, schedulerMessagesEnum.ScheduleMonitor) | translate}}</div>
  <div class="date-selection">
    <mat-form-field appearance="outline" class="select-businessdate nopadding" required>
      <mat-label>{{tranKey(moi.SCHEDULE_MANAGER, schedulerMessagesEnum.ChooseDate) | translate}}</mat-label>
      <input matInput  [(ngModel)]="selectedBusinessDate"  (dateChange)="onDateChanged()" [matDatepicker]="picker">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker  #picker></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="reset"><button mat-raised-button color="primary" (click)="resetStatus()">{{tranKey(moi.SCHEDULE_MANAGER, schedulerMessagesEnum.ResetStatus) | translate}}</button></div>
</div>
<div class="table-container">
  <div class="table-header">
    <div class="venue-cap">{{tranKey(moi.SCHEDULE_MANAGER, schedulerMessagesEnum.Venues) | translate}}</div>
    <div class="sequence-cap" *ngFor="let n of sequences">
      {{n}}
    </div>
  </div>

  <div class="row" *ngFor="let venue of venues">
    <div class="column venue">
      <div class="venue-data">

        <div class="copy">
          <button mat-icon-button class="copy-button" (click)="onCopy(venue.venueId)">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
        <div class="name">{{venue.shortName}}</div>
        <div class="capacity">
          <mat-icon>event_seat</mat-icon> {{venue.defaultVenueSeatPlanReservedCapacity}}
        </div>
      </div>
    </div>
    <div class="column sequence" *ngFor="let n of sequences">
      <app-monitor-event [event]="getEvent(venue.venueId,n)"></app-monitor-event>
    </div>
  </div>
</div>
<div class="legend-container">
  <div class="legend-row">
    <div class="col symbol"><mat-icon>confirmation_number</mat-icon></div>
    <div class="col">{{tranKey(moi.SCHEDULE_MANAGER, schedulerMessagesEnum.SoldQuantity) | translate}}</div>
  </div>
  <div class="legend-row">
    <div class="col symbol"><mat-icon>language</mat-icon></div>
    <div class="col">{{tranKey(moi.SCHEDULE_MANAGER, schedulerMessagesEnum.SoldRemotely) | translate}}</div>
  </div>

  <div class="legend-row">
    <div class="col symbol"><div class="graph soldpercofcapacity"></div></div>
    <div class="col">{{tranKey(moi.SCHEDULE_MANAGER, schedulerMessagesEnum.SoldQuantityOfCapacity) | translate}}</div>
  </div>
  <div class="legend-row">
    <div class="col symbol"><div class="graph soldremotepercofcapacity"></div></div>
    <div class="col">{{tranKey(moi.SCHEDULE_MANAGER, schedulerMessagesEnum.SoldRemotelyOfCapacity) | translate}}</div>
  </div>
</div>
